// Copyright (c) Docugami, Inc. All rights reserved.
import { DOMParser } from '@xmldom/xmldom';
import { DOCUGAMIidConstant } from './DgParagraphMetadataUtil';


/*eslint-disable */

// Note: the following const have eslint-disable because they form the whole of the Open-Xml-Sdk for JavaScript API.
// Most modules will use only a subset of the API, but disabling portions of the API leads to friction when writing
// code.  Disabling eslint for these variables removes the error indicating that a variable is assigned a value but
// never used.  If we ever re-write these modules in TypeScript, then the public API will change significantly.

const Enumerable = require("../../../../../utils/linq");
const Ltxml = require('../../../../../utils/ltxml.js');
Ltxml.DOMParser = DOMParser

const openXml = require('../../../../../utils/openxml');

const XAttribute = Ltxml.XAttribute;
const XCData = Ltxml.XCData;
const XComment = Ltxml.XComment;
const XContainer = Ltxml.XContainer;
const XDeclaration = Ltxml.XDeclaration;
const XDocument = Ltxml.XDocument;
const XElement = Ltxml.XElement;
const XName = Ltxml.XName;
const XNamespace = Ltxml.XNamespace;
const XNode = Ltxml.XNode;
const XObject = Ltxml.XObject;
const XProcessingInstruction = Ltxml.XProcessingInstruction;
const XText = Ltxml.XText;
const XEntity = Ltxml.XEntity;
const cast = Ltxml.cast;
const castInt = Ltxml.castInt;

const W = openXml.W;
const W14 = openXml.W14;
const W15 = openXml.W15;
const NN = openXml.NoNamespace;
const wNs = openXml.wNs;
const groupAdjacent = openXml.groupAdjacent;
/*eslint-enable */

export enum FieldType {
    Simple = "Simple",
    Complex = "Complex",
}

export class WordField {
    public FieldType: FieldType;
    public InstrText: string;

     // set only if FieldType === FieldType.Simple
    public FldSimpleElement: any | null;

    // set only if FieldType === FieldType.Complex
    public ComplexFieldElements: any[] | null;
    public InstrTextElements: any[] | null;

    constructor()
    {
        this.FieldType = FieldType.Simple;
        this.InstrText = "";
        this.ComplexFieldElements = null;
        this.InstrTextElements = null;
    }

    public updateDocugamiId(uuid: string)
    {
        if (this.FieldType === FieldType.Simple) {
            const existingFldSimple = this.FldSimpleElement;
            if (existingFldSimple !== null) {
                existingFldSimple.attribute(W.instr).value = DOCUGAMIidConstant + uuid;
                return;
            }
        }
        if (this.FieldType === FieldType.Complex) {
            const existingInstrTextElements = this.InstrTextElements;
            if (existingInstrTextElements !== null) {
                for (let i = 1; i < existingInstrTextElements.length; ++i) {
                    existingInstrTextElements[i].remove();
                }
                existingInstrTextElements[0].value = DOCUGAMIidConstant + uuid;
            }
        }
        return;
    }

    public remove()
    {
        if (this.FieldType === FieldType.Simple) {
            const existingFldSimple = this.FldSimpleElement;
            existingFldSimple.remove();
        }
        else if (this.FieldType === FieldType.Complex) {
            const complexFieldElements = this.ComplexFieldElements;
            if (complexFieldElements !== null) {
                for (let i = 0; i < complexFieldElements.length; ++i) {
                    complexFieldElements[i].remove();
                }
            }
        }
        return;
    }

    public static getFieldsFromParagraph(paragraph: any): WordField[]
    {
        const sourceChildElements = paragraph.descendants().where((d: any) => d.name === W.r || d.name === W.fldSimple).toArray();

        enum FieldElementType {
            Begin,
            InstrText,
            Separate,
            Contents,
            End,
            NotInField,
            SimpleField,
        };

        enum FieldState {
            NotInField,
            OnBegin,
            OnInstrText,
            OnSeparate,
            OnContents,
            OnEnd,
        };

        class ChildElementInfo {
            public childElement: any;
            public groupId: number;
            public childElementType: FieldElementType;

            constructor(element: any, groupId: number, childType: FieldElementType)
            {
                this.childElement = element;
                this.groupId = groupId;
                this.childElementType = childType;
            }
        }

        let childElements: ChildElementInfo[] = [];
        let state: FieldState = FieldState.NotInField;
        let groupCounter: number = 0;

        for (let childCount = 0; childCount < sourceChildElements.length; ++childCount)
        {
            const childElement = sourceChildElements[childCount];
            if (state === FieldState.NotInField) {
                if (childElement.name === W.fldSimple) {
                    ++groupCounter;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.SimpleField));
                    ++groupCounter;
                    // leave state = FieldState.NotInField;
                    continue;
                }
                if (childElement.elements(W.fldChar).any((childElement: any) => childElement.attribute(W.fldCharType).value === "begin")) {
                    state = FieldState.OnBegin;
                    ++groupCounter;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.Begin));
                    continue;
                }
                childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.NotInField));
                continue;
            }
            if (state === FieldState.OnBegin) {
                if (childElement.elements(W.instrText).any()) {
                    state = FieldState.OnInstrText;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.InstrText));
                    continue;
                }
                throw new Error("Invalid field markup - expected instrText");
            }
            if (state === FieldState.OnInstrText) {
                if (childElement.elements(W.instrText).any()) {
                    // continue in FieldState.OnInstrText state
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.InstrText));
                    continue;
                }
                // it can happen that there is an empty run in between the begin and separate that does not contain any instrText
                // if we find this, continue on in the same state
                if (! childElement.elements().where((ce: any) => ce.name !== W.rPr).any())
                {
                    // continue in FieldState.OnInstrText state
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.InstrText));
                    continue;
                }
                if (childElement.elements(W.fldChar).any((childElement: any) => childElement.attribute(W.fldCharType).value === "separate")) {
                    state = FieldState.OnSeparate;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.Separate));
                    continue;
                }
                if (childElement.elements(W.fldChar).any((childElement: any) => childElement.attribute(W.fldCharType).value === "end")) {
                    state = FieldState.OnEnd;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.End));
                    continue;
                }
                throw new Error("Invalid field markup - expected instrText, separate, or end");
            }
            if (state === FieldState.OnSeparate) {
                if (childElement.elements(W.fldChar).any((childElement: any) => childElement.attribute(W.fldCharType).value === "end")) {
                    state = FieldState.OnEnd;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.End));
                    continue;
                }
                state = FieldState.OnContents;
                childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.Contents));
                continue;
            }
            if (state === FieldState.OnContents) {
                if (childElement.elements(W.fldChar).any((childElement: any) => childElement.attribute(W.fldCharType).value === "end")) {
                    state = FieldState.OnEnd;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.End));
                    continue;
                }
                // leave state in OnContents
                childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.Contents));
                continue;
            }
            if (state === FieldState.OnEnd) {
                // in case the next field starts immediately after the previous field
                if (childElement.elements(W.fldChar).any((childElement: any) => childElement.attribute(W.fldCharType).value === "begin")) {
                    state = FieldState.OnBegin;
                    ++groupCounter;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.Begin));
                    continue;
                }
                if (childElement.name === W.fldSimple) {
                    ++groupCounter;
                    childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.SimpleField));
                    ++groupCounter;
                    state = FieldState.NotInField;
                    continue;
                }
                state = FieldState.NotInField;
                ++groupCounter;
                childElements.push(new ChildElementInfo(childElement, groupCounter, FieldElementType.NotInField));
                continue;
            }
        }

        const groupedElements = Enumerable.from(groupAdjacent(childElements, (ce: ChildElementInfo) => ce.groupId)).toArray();

        const fieldInfoArray: WordField[] = [];

        for (let i = 0; i < groupedElements.length; ++i)
        {
            const group = Enumerable.from(groupedElements[i].Group).toArray();
            let firstElement: any = group[0];
            if (firstElement.childElementType === FieldElementType.NotInField) {
                continue;
            }
            if (firstElement.childElementType === FieldElementType.SimpleField) {
                const simpleFieldInfo = new WordField();
                simpleFieldInfo.FieldType = FieldType.Simple;
                simpleFieldInfo.FldSimpleElement = firstElement.childElement;
                simpleFieldInfo.InstrText = firstElement.childElement.attribute(W.instr).value;
                fieldInfoArray.push(simpleFieldInfo);
                continue;
            }
            if (firstElement.childElementType === FieldElementType.Begin) {
                const complexFieldInfo = new WordField();
                complexFieldInfo.FieldType = FieldType.Complex;
                complexFieldInfo.ComplexFieldElements = Enumerable.from(group).select((ge: ChildElementInfo) => ge.childElement).toArray();
                complexFieldInfo.InstrTextElements = Enumerable.from(group).where((e: ChildElementInfo) => e.childElementType === FieldElementType.InstrText).select((gc: ChildElementInfo) => gc.childElement).toArray();
                complexFieldInfo.InstrText = Enumerable.from(group).where((e: ChildElementInfo) => e.childElementType === FieldElementType.InstrText).select((gc: ChildElementInfo) => gc.childElement.value).toArray().join();
                fieldInfoArray.push(complexFieldInfo);
            }
        }
        return fieldInfoArray;
    }
}
